import { SearchParams } from './search-params.modal';

export class SearchDatePicker extends SearchParams<Date> {
    controlType = 'datepicker'
    
    constructor(options: {} = {}) {
        super(options)
    }
}